<template>
  <div class="PageGuard edit">
    <PageHeaderMobile :pageHeaderTitle="pageHeaderTitle" @goBack="goBack"></PageHeaderMobile>
    <Tabs :tabsData="tabsData" :active="activeTab" @tabClick="getActiveTab" v-if="infoData.reserveData">
      <div slot="basisInfo">
        <GuardBasicInfo
          :key="infoData.reserveData.id"
          :infoData="infoData"
          @linkClick="switchToInspectorForm"
        ></GuardBasicInfo>
      </div>
      <div slot="detailInfo">
        <GuardDetailedInfo :key="infoData.reserveData.id" :infoData="infoData"></GuardDetailedInfo>
      </div>
      <div slot="inspectorForm">
        <Collapse :collapseData="collapseData" :active="activeCollapse" @collapseClick="getActiveCollapse">
          <div slot="entering">
            <Guard1InspectorForm
              :editable="false"
              :inspectData="infoData.inspectData.enteringInspectRecord"
              :checkItemspectData="infoData.inspectData.enteringCheckItems"
              :reserveRegion="infoData.reserveData.reserveRegion"
              :reserveArea="infoData.reserveData.reserveArea"
            >
            </Guard1InspectorForm>
          </div>
          <div slot="in1">
            <Guard2InspectorForm
              @releaseListClick="goReleaseListPage"
              ref="in1InspectRef"
              :isView="false"
              :editable="hasRightSubmit"
              :reserveInfo="infoData"
            >
            </Guard2InspectorForm>
          </div>
          <div slot="in2">
            <Guard3InspectorForm
              @releaseListClick="goReleaseListPage"
              :isView="false"
              :editable="false"
              :reserveInfo="infoData"
            >
            </Guard3InspectorForm>
          </div>
        </Collapse>
      </div>
    </Tabs>
    <ApprovalButtonGroup v-if="hasRightSubmit" @submitFail="submitFail" @submitPass="submitPass"></ApprovalButtonGroup>
  </div>
</template>

<script>
import { api } from "@/utils/api.js"
import { utils } from "@/utils/utils.js"
import PageHeaderMobile from "@/components/common/PageHeaderMobile.vue"
import Tabs from "@/components/common/Tabs.vue"
import Collapse from "@/components/common/Collapse.vue"
import GuardBasicInfo from "@/components/Guard/GuardBasicInfo.vue"
import GuardDetailedInfo from "@/components/Guard/GuardDetailedInfo.vue"
import Guard1InspectorForm from "@/components/Guard/Guard1InspectorForm.vue"
import Guard2InspectorForm from "@/components/Guard/Guard2InspectorForm.vue"
import Guard3InspectorForm from "@/components/Guard/Guard3InspectorForm.vue"
import ApprovalButtonGroup from "@/components/Guard/ApprovalButtonGroup.vue"

export default {
  name: "PageGuard2",
  props: {
    reserveID: {
      type: Number,
      default: -1,
    },
  },
  components: {
    PageHeaderMobile,
    Tabs,
    Collapse,
    GuardBasicInfo,
    GuardDetailedInfo,
    Guard1InspectorForm,
    Guard2InspectorForm,
    Guard3InspectorForm,
    ApprovalButtonGroup,
  },
  data() {
    return {
      reserveDataID: -1,
      pageHeaderTitle: "",
      activeTab: "basisInfo",
      activeCollapse: ["in1"],
      infoData: {},
      hasRightSubmit: false,
    }
  },
  created() {
    this.init()
  },
  methods: {
    async init() {
      this.reserveDataID = this.reserveID
      if (this.reserveDataID === -1) {
        this.reserveDataID = parseInt(window.sessionStorage.getItem("guardall_reserveID"))
      } else {
        window.sessionStorage.setItem("guardall_reserveID", this.reserveDataID)
      }
      if (this.$route.query.reserveNo != null && this.$route.query.ticketCode != null) {
        try {
          this.reserveDataID = await this.getReserveIDByQuerys(
            this.$route.query.reserveNo,
            this.$route.query.ticketCode
          )
        } catch (e) {
          this.$alert("parameters of url is invalid", "", {
            confirmButtonText: this.$t("pages.button.confirm"),
          })
          console.error(e)
          return
        }
      } else {
        this.reserveDataID = this.reserveID
      }
      if (this.reserveDataID === -1) {
        this.reserveDataID = parseInt(window.sessionStorage.getItem("guard2_reserveID"))
      } else {
        window.sessionStorage.setItem("guard2_reserveID", this.reserveDataID)
      }
      this.getReserveInfo()
    },
    getReserveIDByQuerys(reserveNo, ticketCode) {
      return new Promise((resolve, reject) => {
        api
          .apiGetReserveIDByParams({ params: { reserveNo: reserveNo, ticketCode: ticketCode } })
          .then((response) => {
            if (response.data.success) {
              resolve(parseInt(response.data.message))
            } else {
              reject(response.data.message)
            }
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    goBack() {
      this.keepPrveParams()
      this.$router.push({
        name: "PageGuardReservation",
      })
    },
    keepPrveParams() {
      let guardTempQueryParams = window.sessionStorage.getItem("guardTempQueryParams")
      window.sessionStorage.removeItem("guardTempQueryParams")
      window.sessionStorage.setItem("guardQueryParams", guardTempQueryParams)
    },
    getActiveTab(val) {
      this.activeTab = val
    },
    getActiveCollapse(val) {
      this.activeCollapse = val
    },
    getReserveInfo() {
      let vueInstance = this
      api
        .apiGetReserveInfo({ params: { id: vueInstance.reserveDataID } })
        .then((response) => {
          vueInstance.infoData = response.data.result
          vueInstance.pageHeaderTitle = response.data.result.reserveData.reserveNo
          return vueInstance.infoData.reserveData
        })
        .then((reserveData) => {
          vueInstance.checkUserHasRightToSubmit(reserveData.reserveArea)
        })
        .catch((error) => {
          console.error(error)
        })
    },
    checkUserHasRightToSubmit(area) {
      let params = {
        area: area,
        station: 2,
      }
      api
        .apiGetGuardRight(params)
        .then((response) => {
          if (response.data) {
            const { canWork, needShift, noRightMessage } = response.data
            this.hasRightSubmit = canWork
            if (!canWork && needShift) {
              this.$alert(this.$t("message.alert.backend." + noRightMessage), "", {
                confirmButtonText: this.$t("pages.button.confirm"),
              })
            }
          }
        })
        .catch((error) => {
          console.error(error)
        })
    },
    switchToInspectorForm(collapseName) {
      this.activeTab = "inspectorForm"
      this.activeCollapse = [collapseName]
    },
    submitPass() {
      let vueInstance = this
      let submitType = "PASS"
      if (vueInstance.$global.erpReserveType.includes(vueInstance.infoData.reserveData.reserveType)) {
        api
          .apiCheckReleaseAllFinishedSign({ params: { reserveID: vueInstance.reserveDataID } })
          .then((response) => {
            if (!response.data.success) {
              utils.alertMessage(vueInstance, 1, vueInstance.$t("message.alert.systemOccursError"))
              return
            }
            if (response.data.result) {
              vueInstance.updateReserveData(submitType)
            } else {
              if (response.data.notsignList !== undefined) {
                let warningDetailMsg = vueInstance.$t("message.alert.releaseSignProcessNotComplete") + "<br/>"
                let notSignList = response.data.notsignList
                Object.keys(notSignList).forEach((key) => {
                  let rolesNames = []
                  response.data.notsignList[key].forEach((element) =>
                    rolesNames.push(vueInstance.$t("role." + element))
                  )
                  warningDetailMsg += `${key}：${rolesNames.join("、")}${vueInstance.$t("pages.wording.notYetSign")}`
                  warningDetailMsg += "<br/>"
                })
                utils.alertMessage(vueInstance, 1, warningDetailMsg)
              } else {
                utils.alertMessage(vueInstance, 1, vueInstance.$t("message.alert.releaseNotYetApproved"))
              }
            }
          })
          .catch((error) => {
            console.error(error)
          })
      } else {
        vueInstance.updateReserveData(submitType)
      }
    },
    submitFail() {
      this.updateReserveData("FAIL")
    },
    updateReserveData(submitType) {
      let vueInstance = this
      let genResult = vueInstance.generateSubmitParams(submitType)
      if (genResult.success == false) {
        vueInstance.activeTab = "inspectorForm"
        return
      }
      utils.showLoading(vueInstance)
      api
        .apiUpdateReserveFlow(genResult.dataParams)
        .then((response) => {
          if (response.data) {
            if (response.data.success) {
              vueInstance.keepPrveParams()
              utils.closeLoading(vueInstance)
              vueInstance.$message({
                message: vueInstance.$t("message.alert.successSubmit"),
                type: "success",
              })
              vueInstance.$router.push({ name: "PageGuardReservation" })
            } else {
              utils.closeLoading(vueInstance)
              this.$alert(vueInstance.$t("pages.wording.occursWhenProcessReserveFlow"), "", {
                confirmButtonText: vueInstance.$t("pages.button.confirm"),
              })
            }
          }
        })
        .catch((error) => {
          utils.closeLoading(vueInstance)
          console.error(error)
        })
    },
    generateSubmitParams(submitType) {
      let submitStatus = "in1"
      let reserveData = this.infoData.reserveData
      let inspectResult = this.$refs.in1InspectRef.getInspectData()
      if (inspectResult.success === false) {
        return { success: false }
      }
      if (inspectResult.formData.isDelay && inspectResult.formData.delayReason === null) {
        this.$alert(
          `${this.$t("pages.wording.pleaseSelectAn")}${this.$t("pages.wording.delayReason").toLowerCase()}`,
          "",
          {
            confirmButtonText: this.$t("pages.button.confirm"),
          }
        )
        return { success: false }
      }
      if (submitType === "FAIL") {
        if (inspectResult.formData.failReason === null) {
          this.$alert(
            `${this.$t("pages.wording.pleaseSelect")}${this.$t("pages.wording.failReason").toLowerCase()}`,
            "",
            {
              confirmButtonText: this.$t("pages.button.confirm"),
            }
          )
          return { success: false }
        }
        //不合格原因
        inspectResult.formData.inspectItem.push({
          itemType: "select",
          // item: "s2-5",
          description: "UnqualifiedReason",
          resValue: inspectResult.formData.failReason,
          result: true,
        })
      }
      reserveData.stayReason = inspectResult.formData.delayReason
      let inspect = {
        inspectType: submitStatus,
        inspectStatus: submitType,
        inspectRemark: inspectResult.formData.remark,
      }
      //檢查結果
      inspectResult.formData.inspectItem.push({
        itemType: "radio",
        // item: "s2-4",
        description: "CheckResult",
        resValue: submitType,
        result: submitType === "PASS" ? true : false,
      })
      let params = {
        reserveID: reserveData.id,
        reserveType: reserveData.reserveType,
        nowStatus: submitStatus,
        isPass: submitType === "FAIL" ? false : true,
        inputJsonObject: {
          reserveData: reserveData,
          inspectData: inspect,
          inspectItems: inspectResult.formData.inspectItem,
        },
      }
      return { success: true, dataParams: params }
    },
    goReleaseListPage() {
      let guardTempReleaseParams = {
        reserveDataID: this.reserveDataID,
        station: "PageGuardReservation_in1",
      }
      window.sessionStorage.setItem("guardTempReleaseParams", JSON.stringify(guardTempReleaseParams))
      this.$router.push({
        name: "PageGuardReservationReleaseList",
        params: { reserveID: this.reserveDataID },
      })
    },
  },
  computed: {
    tabsData() {
      return [
        {
          name: "basisInfo",
          label: this.$t("pages.wording.basisInfo"),
        },
        {
          name: "detailInfo",
          label: this.$t("pages.wording.detailInfo"),
        },
        {
          name: "inspectorForm",
          label: this.$t("pages.wording.inspectorForm"),
        },
      ]
    },
    collapseData() {
      return [
        {
          title: this.$t("pages.wording.entering"),
          name: "entering",
        },
        {
          title: this.$t("pages.wording.in1"),
          name: "in1",
        },
        {
          title: this.$t("pages.wording.in2"),
          name: "in2",
        },
      ]
    },
  },
}
</script>
<style scoped>
.PageGuard {
  margin: 0 -20px -20px -20px;
  padding-top: 20px;
}
.PageGuard.edit {
  padding-bottom: 20px;
}
.Tabs ::v-deep .el-collapse-item:last-child .el-collapse-item__content {
  padding-bottom: 4px;
}
</style>
